import { jsx, jsxs } from "react/jsx-runtime";
import styled, { keyframes } from "styled-components";
import { token } from "./token.js";
import { IconContainer, SvgIcon } from "./styles2.js";
const indicatorIcons = {
  draft: DraftIcon,
  error: ErrorIcon,
  loading: LoadingIcon,
  negative: NegativeIcon,
  positive: PositiveIcon
};
function Indicator({
  ...props
}) {
  if ("type" in props) {
    const {
      type,
      ...otherProps2
    } = props;
    const Icon = indicatorIcons[type];
    return /* @__PURE__ */ jsx(Icon, {
      "data-thumbnail-indicator": true,
      ...otherProps2
    });
  }
  const {
    backgroundColor,
    iconColor,
    icon,
    ...otherProps
  } = props;
  return /* @__PURE__ */ jsx(IconContainer, {
    $backgroundColor: backgroundColor || "gray400",
    $iconColor: iconColor || "white",
    "data-thumbnail-indicator": true,
    ...otherProps,
    children: icon
  });
}
function PositiveIcon({
  ...props
}) {
  return /* @__PURE__ */ jsxs(SvgIcon, {
    ...props,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: token.teal500,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 0 12 "
    }), /* @__PURE__ */ jsx("path", {
      d: "m5.69215,11.43763c-0.58607,0.58607 -0.58607,1.53629 0,2.12236l3.18355,3.18363c0.21978,0.21971 0.49077,0.35703 0.77456,0.41195c0.12714,0.02461 0.25685,0.03272 0.38568,0.02431c0.35044,-0.02311 0.69432,-0.16853 0.96216,-0.43627l7.42831,-7.42836c0.58604,-0.58608 0.58604,-1.53629 0,-2.12238c-0.58604,-0.58607 -1.53631,-0.58607 -2.12235,0l-6.36715,6.36712l-2.12238,-2.12238c-0.58608,-0.58608 -1.53629,-0.58608 -2.12238,0z",
      fill: "white"
    })]
  });
}
function NegativeIcon({
  ...props
}) {
  return /* @__PURE__ */ jsxs(SvgIcon, {
    ...props,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: token.red400,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 0 12 "
    }), /* @__PURE__ */ jsx("path", {
      d: "M 17.304688 6.695312 C 16.71875 6.109375 15.769531 6.109375 15.183594 6.695312 L 12 9.878906 L 8.816406 6.695312 C 8.230469 6.109375 7.28125 6.109375 6.695312 6.695312 C 6.109375 7.28125 6.109375 8.230469 6.695312 8.816406 L 9.878906 12 L 6.695312 15.183594 C 6.109375 15.769531 6.109375 16.71875 6.695312 17.304688 C 7.28125 17.890625 8.230469 17.890625 8.816406 17.304688 L 12 14.121094 L 15.183594 17.304688 C 15.769531 17.890625 16.71875 17.890625 17.304688 17.304688 C 17.890625 16.71875 17.890625 15.769531 17.304688 15.183594 L 14.121094 12 L 17.304688 8.816406 C 17.890625 8.230469 17.890625 7.28125 17.304688 6.695312 Z M 17.304688 6.695312",
      fill: "white"
    })]
  });
}
function ErrorIcon({
  ...props
}) {
  return /* @__PURE__ */ jsxs(SvgIcon, {
    ...props,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: token.red400,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 0 12 "
    }), /* @__PURE__ */ jsx("path", {
      d: "M 13.5 4.5 L 10.5 4.5 L 10.5 13.5 L 13.5 13.5 Z M 13.5 4.5 ",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M 13.5 16.5 L 10.5 16.5 L 10.5 19.5 L 13.5 19.5 Z M 13.5 16.5 ",
      fill: "white"
    })]
  });
}
function DraftIcon({
  ...props
}) {
  return /* @__PURE__ */ jsxs(SvgIcon, {
    ...props,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: token.gray400,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 0 12 "
    }), /* @__PURE__ */ jsx("path", {
      d: "M 7.5 10.5 C 6.671875 10.5 6 11.171875 6 12 C 6 12.828125 6.671875 13.5 7.5 13.5 C 8.328125 13.5 9 12.828125 9 12 C 9 11.171875 8.328125 10.5 7.5 10.5 Z M 10.5 12 C 10.5 11.171875 11.171875 10.5 12 10.5 C 12.828125 10.5 13.5 11.171875 13.5 12 C 13.5 12.828125 12.828125 13.5 12 13.5 C 11.171875 13.5 10.5 12.828125 10.5 12 Z M 15 12 C 15 11.171875 15.671875 10.5 16.5 10.5 C 17.328125 10.5 18 11.171875 18 12 C 18 12.828125 17.328125 13.5 16.5 13.5 C 15.671875 13.5 15 12.828125 15 12 Z M 15 12 ",
      fill: "white"
    })]
  });
}
function LoadingIcon({
  ...props
}) {
  return /* @__PURE__ */ jsx(SvgIcon, {
    ...props,
    viewBox: "0 0 14 14",
    "aria-hidden": "true",
    fill: token.gray400,
    children: /* @__PURE__ */ jsx(SvgSpinner, {
      cx: "7",
      cy: "7",
      r: "5",
      fill: "transparent",
      strokeWidth: "2"
    })
  });
}
const dash = keyframes`
	0% {
		transform: rotate(0deg);
		stroke-dashoffset: 6.6;
	}

	50% {
		transform: rotate(720deg);
		stroke-dashoffset: 31.4;
	}

	100% {
		transform: rotate(1080deg);
		stroke-dashoffset: 6.6;
	}
`;
const SvgSpinner = styled.circle.withConfig({
  displayName: "SvgSpinner",
  componentId: "sc-cmirl-0"
})(["stroke:", ";transform-origin:center;animation:", " 2s linear infinite;stroke-dasharray:31.4;stroke-linecap:round;"], (props) => props.$color || token.gray400, dash);
export {
  Indicator
};
//# sourceMappingURL=Indicator.js.map
